<template>
  <section class="container">
    <div class="route">{{ $locales.condicionesespeciales.condicionesespeciales }} > {{ $locales.condicionesespeciales.anticipoautomatico }}</div>
    <div class="sidebar">
      <span class="principal">{{ $locales.condicionesespeciales.condicionesespeciales }}</span>
      <ul>
        <li>
          <router-link to="/onesaitConfirmingProviders/condiciones-especiales/cuenta-abono" class="link"
            >{{ $locales.condicionesespeciales.cuentaabono }}</router-link
          >
        </li>
        <li @click="refresh">
          <router-link
            to="/onesaitConfirmingProviders/condiciones-especiales/anticipo-automatico"
            class="link-active"
            >{{ $locales.condicionesespeciales.anticipoautomatico }}</router-link
          >
        </li>
      </ul>
    </div>
    <div class="window">
      <div class="mensajeConfirmacion" v-if="confirmacion=='OK'">
          <p>check_circle</p>
          <h3>Operación realizada con éxito</h3>
       </div>
       <div class="mensajeError" v-else-if="confirmacion=='KO'">
          <p>cancel</p>
          <h3>{{mensajeError}}</h3>
       </div>
      <h1>{{ $locales.condicionesespeciales.anticipoautomatico }}</h1>
      <div class="form-group">
        <form class="window-form" @submit.prevent="aceptar">
          <div :class = "deudores.length > 5 ? 'deudores-list-automatic-advance' : 'deudores-list-automatic-advance-low-list'" v-if="deudores && deudores.length >= 1">
            <div class="row" v-for="(registro,index) in deudores" :key="index">
              <div id="columnaAnticipo"> 
                <div class="margenCheckSwitch">                     
                  <md-checkbox id="nombre + index" name="nombre + index" v-model="registro.automaticAdvance">{{registro.name}} - {{registro.contractId}}</md-checkbox>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="deudores && deudores.length < 1">No hay deudores para mostrar</div>
          <div v-if="deudores && deudores.length >= 1">
            <p id="subTextMarkedOrders">
              La firma electrónica, implica la cesión de los créditos/facturas cuyo anticipo ha solicitado usted,
              sometida dicha cesión a la expresa aceptación de la Entidad Cesionaria. A su vez usted declara conocer y aceptar tanto las condiciones
              particulares mostradas en las distintas pantallas de solicitud de anticipo, como las condiciones generales del contrato indicadas
              en el pdf siguiente.<br><br><br>
            </p>
            <div @click="downloadPdf" class="downloadPdf">
              <!--<img id="adPayMarkImg" src="../assets/img/pdf-icon.png" alt="Descarga pdf"> -->
              <a id="pdfParticularConditions">S</a>
              <a id="textParticularConditions">Condiciones Anticipo Automático</a>
            </div>
            <br/>
            <div class="margenCheckSwitch">
              <md-checkbox :disabled="isDisabledCheck"  @change="onCheck" v-model="condiciones">He leído y aceptado las Condiciones EurocajaRuralConfirming</md-checkbox>
            </div>
            <!-- Boton aceptar -->
            <input class="btnPrimary" type="submit" value="Aceptar" :disabled="isDisabled" v-if="beforeSubmit"/>
          </div>
          <br/>
          <div v-if=datosFirma>
                <SignatureComponent :params="params" :datosFirma="datosFirma" :llamada="llamada" @aceptar="callBackAceptar" @cancelar="callBackCancelar"></SignatureComponent>
          </div>
        </form>
      </div> 
    </div>
  </section>
</template>

<script>
import AutomaticAdvance from "../models/AutomaticAdvance";
import SignatureComponent from './SignatureComponent';
import download from 'downloadjs';
export default {
  name: "AutomaticAdvanceComponent",
  data() {
    return {
      boolean: true,
      active: true,
      active2: false,
      submitted: false,
      beforeSubmit: true,
      mensajeError: null,
      datosFirma: null,
      confirmacion: null,
      llamada: null,
      isDisabledCheck:true,
      condiciones:false,
      isDisabled:true,
      queries:null,
      params:null,
      model: new AutomaticAdvance(),
      deudores:[], 
    };
  },

  created: function(){ //llamada a /api-confirming/supplier/debtors
    const baseURI = '/api-confirming/confirming/supplier/debtors';
    let loader = this.$loading.show();
    var ventana=this;
    this.$http.get(baseURI)
          .then((result) => {
            //una vez termina de paginar, procedo a formatear datos para que se vean correctamente
            result.data.data.forEach(deudor => {
                  deudor.contractId = deudor.contractId.replace(/^0+/, '');
                  if(deudor.relatedAccount) {
                    deudor.relatedAccount = deudor.relatedAccount.formats[0].value;
                  }
                  this.deudores.push(deudor);
            });
          })
          .catch(error => {
            var codError = error.response.data.result.errors[0].errorCode;
            var descError = error.response.data.result.errors[0].errorDescription;
            ventana.mensajeError = codError + " - " + descError;
            ventana.confirmacion = "KO";
            window.scroll({
              top: 0,
              left: 0,
              behavior: 'smooth'
            });
          })
          .then(function () {
            loader.hide();
          });
  },
  components: {
    SignatureComponent
  },
  /*computed: {
    isDisabled: function () {
      return !this.model.account;
    },
  },*/
  validations: {
    model: {  

      
    },
  },
  methods: {
    refresh(){ //esto tiene la funcion de refrescar el componente cuando volvemos a clickar sobre el en las NavigationBars
        this.$parent.keyRefresh+=1; //al cambiar la key de esta section que lo abarca todo, vue dispara un update
    },
    downloadPdf() {
      const ventana=this;
      var idgdoc='f19997ee-f8fd-4e2d-b1d0-7a2ef30d8b31'; //el de eurocaja PRO por defecto por si la parametrizacion no funciona
      switch(location.origin){
        case 'http://localhost:8080':{ //local
          idgdoc='c92fc714-6d35-4d7f-a182-f0f3c2036748';
          break;
        }
        case 'https://10.31.18.15':{ //desa prod
          idgdoc='c92fc714-6d35-4d7f-a182-f0f3c2036748';
          break;
        }
        case 'https://10.31.132.5':{ //ec pre
          idgdoc='5bb423f9-fda0-4a12-adee-f02e7e242603';
          break;
        }
        case 'https://onesaitportal.eurocajarural.es':{ //ec pro
          idgdoc='f0bfd9f2-44ce-497c-a547-32acb447da83';
          break;
        }
      }
      const baseURI = '/api-documents/documents/'+idgdoc;
      this.llamada = {
        urlEndpoint : baseURI,
        metodo : 'GET'
      };     
      let loader = this.$loading.show();
      this.$http.get(baseURI, {responseType: 'blob'})
      .then((result) => {
        const content = result.headers['content-type'];
        if(download(result.data, "AceptacionCondicionesAnticipoAutomatico", content)){ //si la descarga va bien
          var blob = new Blob([result.data], { type: 'application/pdf' });
          var url = window.URL.createObjectURL(blob);
          window.open(url); //abrimos el pdf
          this.flagCondiciones=true;
            if(this.flagCondiciones == true) {
              this.isDisabledCheck=false; //una vez descargado y abierto el pdf, habilitamos el check de que ha leido de las condiciones
            }
        }
      })
      .catch(error => {
        var codError = null;
        var descError = null;
        if(error.response){ 
          if(error.response.status != 200) {
              if(error.response.data.result) {
                codError = error.response.data.result.errors[0].errorCode;
                descError = error.response.data.result.errors[0].errorDescription;
              } else if(error.response.data.error) {
                codError = error.response.data.error;
                descError = error.response.data.error_description;
              }else {
                codError = "400";
                descError = "No se ha podido descargar el pdf";
              }
              ventana.mensajeError = codError + " - " + descError;
              ventana.confirmacion = "KO";
              window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
              });
          }
        }else{ //si no, por defecto
          ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
          ventana.confirmacion='KO';
        }
      })
      .then(function () {
        loader.hide();
      });
    },
    onCheck(e) {
      if(e) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
    callBackAceptar(confirmacion, mensaje){
      
      if(confirmacion == 'KO') {
        this.beforeSubmit = false;
        this.confirmacion = confirmacion;
        this.mensajeError = mensaje;
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      } else {
        this.aceptarTrasFirmar();
      }
    },
     callBackCancelar(){
         this.beforeSubmit = true;
         this.datosFirma = null;
      },
    showNewLoader() {
        //let homeCont = this.$refs.homeCont;
        let loader = this.$loading.show({
          //container: homeCont
        });
        setTimeout(() => {
          loader.hide();
        }, 3000);
      },

      aceptar() {
        const baseURI = '/api-signatures/signatures';
        this.llamada = {
          urlEndpoint : baseURI,
          metodo : 'POST'
        }; 
        let loader = this.$loading.show();
        var ventana=this;
        const options = {
          params: {
              'signatureType':'PASSWORD'
          }
        };
        this.$http.get(baseURI,options)
          .then((result) => {
            this.datosFirma = result.data.data;
            this.beforeSubmit = false;
            loader.hide();
          })
          .catch(error => {
            var codError = error.response.data.result.errors[0].errorCode;
            var descError = error.response.data.result.errors[0].errorDescription;
            ventana.mensajeError = codError + " - " + descError;
            ventana.confirmacion = "KO";
            window.scroll({
              top: 0,
              left: 0,
              behavior: 'smooth'
            });
          })
          .then(function () {
            loader.hide();
          });
      },
      
     
     aceptarTrasFirmar() {////SE ENVIAN LOS DATOS AL SERVICIO
      this.submitted = true;
      this.confirmacion = null;
      this.$v.$touch();
      if(this.$v.$invalid) {
        return false;
      }else {
        const ventana=this;
        const baseURI = '/api-confirming/confirming/supplier/debtors';
        
        this.llamada = {
          urlEndpoint : baseURI,
          metodo : 'PUT'
        };

        this.queries = {
          'userConditions': 1
        };     
        let loader = this.$loading.show();
        var i = 0;
        this.llamadaRecursiva(ventana,baseURI,loader,i);
      }
    },


    llamadaRecursiva (ventana,baseURI,loader,i) {
      const options = {
          params: {
            'userConditions' : 1
          }
        };
        if(i < ventana.deudores.length) {
          this.params = {
            contractId : this.deudores[i].contractId,
            name : this.deudores[i].name,
            automaticAdvance : this.deudores[i].automaticAdvance,
            relatedAccount : this.deudores[i].relatedAccount
          };        
          this.$http.put(baseURI, this.params, options)
          .then(() => {
            i++;
            this.llamadaRecursiva(ventana,baseURI,loader,i,options);
            ventana.confirmacion='OK';
          })
          .catch(error => {
            if(error.response){
              var codError = null; 
              var descError = null;
              if(error.response.status != 200) {
                if(error.response.data.result.errors[0].errorCode == "096H") {
                  this.datosFirma = error.response.data.result.errors[0].info;
                  this.beforeSubmit = false;
                  loader.hide();
                } else if(error.response.data.result.errors[0].errorCode == "313I"){
                  i++;
                  this.llamadaRecursiva(ventana,baseURI,loader,i);
                  codError = error.response.data.result.errors[0].errorCode;
                  descError = error.response.data.result.errors[0].errorDescription;
                  this.mensajeError = codError + " - " + descError;
                } else {
                  codError = error.response.data.result.errors[0].errorCode;
                  descError = error.response.data.result.errors[0].errorDescription;
                  this.mensajeError = codError + " - " + descError;
                  this.confirmacion = "KO";
                  window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                  });
                  loader.hide();
                }
              }
            }else{ //si no, por defecto
              ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
              ventana.confirmacion='KO';
            }
          })
          .then(function () {
            if(i==ventana.deudores.length) {
              if(ventana.confirmacion != 'OK'){
                ventana.confirmacion = 'KO';
              }
              ventana.beforeSubmit= false;
              ventana.datosFirma =null;
              window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
              }); 
              loader.hide();
            }
          });
        }
      }
  },
};
</script>


